import React from 'react';

// Source: https://brandeps.com/logo/D/Discover-Card-01
// Transformed into <svg> tag with @svgr/cli
export const Discover = () => (
  <svg
    width="100%"
    id="discover_svg__Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="18 97 500 300"
    xmlSpace="preserve"
    aria-hidden
    data-testid="discover-logo"
  >
    <style>{'.discover_svg__st2{fill:#231f20}'}</style>
    <path
      id="discover_svg__XMLID_428_"
      fill="#fff"
      d="M61.3 129.9h377.3v240.2H61.4z"
    />
    <path
      id="discover_svg__XMLID_427_"
      d="M437.3 263.5s-103.1 72.7-291.9 105.3h291.9V263.5z"
      fill="#f48120"
    />
    <path
      id="discover_svg__XMLID_2_"
      className="discover_svg__st2"
      d="M438.6 128.5H60v243h380V128.4h-1.4v.1zm-1.3 2.7v237.5H62.8V131.2h374.5z"
    />
    <path
      className="discover_svg__st2"
      d="M93.2 202.8H77.5v55h15.7c8.3 0 14.3-2 19.6-6.3 6.3-5.2 10-13 10-21.1-.1-16.3-12.2-27.6-29.6-27.6zm12.6 41.4c-3.4 3-7.7 4.4-14.7 4.4h-2.9v-36.4h2.9c6.9 0 11.1 1.2 14.7 4.4 3.7 3.3 5.9 8.4 5.9 13.7 0 5.3-2.2 10.6-5.9 13.9z"
    />
    <path
      id="discover_svg__XMLID_422_"
      className="discover_svg__st2"
      d="M127.7 202.8h10.7v55h-10.7z"
    />
    <path
      id="discover_svg__XMLID_421_"
      className="discover_svg__st2"
      d="M164.6 223.9c-6.4-2.4-8.3-4-8.3-6.9 0-3.5 3.4-6.1 8-6.1 3.2 0 5.9 1.3 8.6 4.5l5.6-7.3c-4.6-4-10.1-6.1-16.2-6.1-9.7 0-17.2 6.8-17.2 15.8 0 7.6 3.5 11.5 13.5 15.1 4.2 1.5 6.3 2.5 7.4 3.1 2.1 1.4 3.2 3.4 3.2 5.7 0 4.5-3.5 7.8-8.3 7.8-5.1 0-9.2-2.6-11.7-7.3l-6.9 6.7c4.9 7.3 10.9 10.5 19 10.5 11.1 0 19-7.4 19-18.1.2-8.9-3.5-12.9-15.7-17.4z"
    />
    <path
      id="discover_svg__XMLID_420_"
      className="discover_svg__st2"
      d="M183.8 230.4c0 16.2 12.7 28.7 29 28.7 4.6 0 8.6-.9 13.4-3.2v-12.6c-4.3 4.3-8.1 6-12.9 6-10.8 0-18.5-7.8-18.5-19 0-10.6 7.9-18.9 18-18.9 5.1 0 9 1.8 13.4 6.2V205c-4.7-2.4-8.6-3.4-13.2-3.4-16.1 0-29.2 12.8-29.2 28.8z"
    />
    <path
      id="discover_svg__XMLID_419_"
      className="discover_svg__st2"
      d="M311.4 239.8l-14.7-37H285l23.3 56.4h5.8l23.7-56.4h-11.6z"
    />
    <path
      id="discover_svg__XMLID_418_"
      className="discover_svg__st2"
      d="M342.7 257.8h30.4v-9.3h-19.7v-14.8h19v-9.3h-19v-12.2h19.7v-9.4h-30.4z"
    />
    <path
      className="discover_svg__st2"
      d="M415.6 219.1c0-10.3-7.1-16.2-19.5-16.2h-15.9v55h10.7v-22.1h1.4l14.8 22.1h13.2L403 234.7c8.1-1.7 12.6-7.2 12.6-15.6zm-21.6 9.1h-3.1v-16.7h3.3c6.7 0 10.3 2.8 10.3 8.2 0 5.5-3.6 8.5-10.5 8.5z"
    />
    <linearGradient
      id="discover_svg__XMLID_3_"
      gradientUnits="userSpaceOnUse"
      x1={274.075}
      y1={246.053}
      x2={253.821}
      y2={277.765}
      gradientTransform="matrix(1 0 0 -1 0 500)"
    >
      <stop offset={0} stopColor="#f89f20" />
      <stop offset={0.25} stopColor="#f79a20" />
      <stop offset={0.533} stopColor="#f68d20" />
      <stop offset={0.62} stopColor="#f58720" />
      <stop offset={0.723} stopColor="#f48120" />
      <stop offset={1} stopColor="#f37521" />
    </linearGradient>
    <circle
      id="discover_svg__XMLID_415_"
      cx={259.1}
      cy={230.5}
      r={29.3}
      fill="url(#discover_svg__XMLID_3_)"
    />
    <linearGradient
      id="discover_svg__XMLID_4_"
      gradientUnits="userSpaceOnUse"
      x1={270.878}
      y1={246.48}
      x2={241.276}
      y2={304.338}
      gradientTransform="matrix(1 0 0 -1 0 500)"
    >
      <stop offset={0} stopColor="#f58720" />
      <stop offset={0.359} stopColor="#e16f27" />
      <stop offset={0.703} stopColor="#d4602c" />
      <stop offset={0.982} stopColor="#d05b2e" />
    </linearGradient>
    <circle
      id="discover_svg__XMLID_414_"
      cx={259.1}
      cy={230.5}
      r={29.3}
      opacity={0.65}
      fill="url(#discover_svg__XMLID_4_)"
    />
    <g id="discover_svg__XMLID_436_">
      <path
        className="discover_svg__st2"
        d="M422.4 204.9c0-1-.7-1.5-1.8-1.5H419v4.8h1.2v-1.9l1.4 1.9h1.4l-1.6-2c.6-.1 1-.6 1-1.3zm-2 .7h-.2v-1.3h.2c.6 0 .9.2.9.6 0 .5-.3.7-.9.7z"
      />
      <path
        className="discover_svg__st2"
        d="M420.8 201.6c-2.3 0-4.2 1.9-4.2 4.2s1.9 4.2 4.2 4.2c2.3 0 4.2-1.9 4.2-4.2s-1.9-4.2-4.2-4.2zm0 7.7c-1.8 0-3.4-1.5-3.4-3.5 0-1.9 1.5-3.5 3.4-3.5 1.8 0 3.3 1.6 3.3 3.5s-1.5 3.5-3.3 3.5z"
      />
    </g>
  </svg>
);
